var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardPanel',{attrs:{"title":"近12个月收缴率趋势","meta":"单位：%"}},[_c('div',{ref:"chart",staticClass:"collection-trend"})])
}
var staticRenderFns = []

export { render, staticRenderFns }